import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
var LogService = /** @class */ (function () {
    function LogService(router) {
        this.router = router;
        this.logs = [];
    }
    LogService.prototype.setLog = function (event) {
        this.logs.push({ url: this.router.url, event: event, time: Date.now() });
    };
    LogService.prototype.getLog = function () {
        var logs = this.logs;
        this.logs = [];
        return logs;
    };
    LogService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    LogService.ctorParameters = function () { return [
        { type: Router }
    ]; };
    return LogService;
}());
export { LogService };
var Log = /** @class */ (function () {
    function Log() {
    }
    return Log;
}());
export { Log };
//# sourceMappingURL=log.service.js.map